import { render, staticRenderFns } from "./LegacyIntro.vue?vue&type=template&id=7788362a&scoped=true"
import script from "./LegacyIntro.vue?vue&type=script&lang=js"
export * from "./LegacyIntro.vue?vue&type=script&lang=js"
import style0 from "./LegacyIntro.vue?vue&type=style&index=0&id=7788362a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7788362a",
  null
  
)

export default component.exports